import config from "@/config"
import http from "@/utils/request"

export default {
	getCategoryList: {
		url: `${config.API_URL}/bwmall/admin.PageCategory/getCategoryList`,
		name: "获取页面分类列表",
		get: async function(params){
			return await http.get(this.url, params);
		}
	},
	selectLinkList: {
		url: `${config.API_URL}/bwmall/admin.pageLink/selectLinkList`,
		name: "装修选择接口",
		get: async function(params){
			return await http.get(this.url, params);
		}
	},
    addCategory: {
		url: `${config.API_URL}/bwmall/admin.PageCategory/addCategory`,
		name: "添加页面分类",
		get: async function(params){
			return await http.get(this.url, params);
		},
        post: async function(params){
			return await http.post(this.url, params);
		},
	},
    editCategory: {
		url: `${config.API_URL}/bwmall/admin.PageCategory/editCategory`,
		name: "编辑页面分类",
        post: async function(params){
			return await http.post(this.url, params);
		},
	},
    delCategory: {
		url: `${config.API_URL}/bwmall/admin.PageCategory/delCategory`,
		name: "删除页面分类",
        post: async function(params){
			return await http.post(this.url, params);
		},
	},
	index:{
		url: `${config.API_URL}/bwmall/admin.pageLink/getLinkList`,
		name: "获取页面链接列表",
		get: async function(params){
			return await http.get(this.url, params);
		}
	},
	addLink: {
		url: `${config.API_URL}/bwmall/admin.pageLink/addLink`,
		name: "添加页面链接",
		get: async function(params){
			return await http.get(this.url, params);
		},
        post: async function(params){
			return await http.post(this.url, params);
		},
	},
	delLink:{
		url: `${config.API_URL}/bwmall/admin.pageLink/delLink`,
		name: "删除页面链接",
        post: async function(params){
			return await http.post(this.url, params);
		},
	},
	editLink: {
		url: `${config.API_URL}/bwmall/admin.pageLink/editLink`,
		name: "编辑页面链接",
		get: async function(params){
			return await http.get(this.url, params);
		},
        post: async function(params){
			return await http.post(this.url, params);
		},
	},
}
